'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'staggeredReveal', () => ({

		cards: document.querySelectorAll( '.staggered-reveal' ),

		fadeIn() {
			this.cards.forEach( card => {
				setTimeout( () => {
					card.classList.add( 'revealed' );
				}, parseInt( card.dataset.counter ) * 300 );
			});
		},

	}) );
});
